import { keepPreviousData } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'

import { parseProvider } from '../../models/Provider'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsLearningItems } from '../useInvalidate'

export default function useProviderSuggestions(init?: string | null) {
  const [query, setQuery] = useState(init)

  const [currentQuery, debounceState] = useDebounce(query, 300)

  const result = useApiQuery({
    queryKey: ['providerSuggestions', ReturnsLearningItems, currentQuery],
    placeholderData: keepPreviousData,
    queryFn: async () =>
      parseProvider
        .array((await api.get(`provider?page=1&page_size=10&search=${encodeURIComponent(currentQuery || '')}`))?.data)
        .filter(({ error }) => !error),
  })

  const suggestions = useMemo(() => result.data || [], [result.data])

  return {
    query,
    setQuery,
    suggestions,
    isFetching: result.isFetching || debounceState.isPending(),
    result,
  }
}
